/** admin/import — KEYS. */
export const adminImportKeys = {
  all: () => ['admin', 'import'] as const,
  jobs: (page: number, limit: number) => [...adminImportKeys.all(), 'jobs', page, limit] as const,
  job: (id: string) => [...adminImportKeys.all(), 'job', id] as const,
};
